 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AboutUs":"AboutUs","AllUsersList":"AllUsersList","ContactUs":"ContactUs","allCategoriesPage":"allCategoriesPage","assignement":"assignement","assignmentBrief":"assignmentBrief","categoryProject":"categoryProject","contest":"contest","contestQuiz~courseCategory~courseQuiz~interviewContestDashboard":"contestQuiz~courseCategory~courseQuiz~interviewContestDashboard","contestQuiz":"contestQuiz","courseCategory~publicCourseDescription":"courseCategory~publicCourseDescription","courseCategory":"courseCategory","courseQuiz":"courseQuiz","interviewContestDashboard":"interviewContestDashboard","publicCourseDescription":"publicCourseDescription","courseDetail":"courseDetail","courseList":"courseList","coursesBycategory":"coursesBycategory","coursesdescription~interViewCourseDetails~testimonials":"coursesdescription~interViewCourseDetails~testimonials","coursesdescription":"coursesdescription","interViewCourseDetails":"interViewCourseDetails","testimonials":"testimonials","forgotPassword":"forgotPassword","globalNotifcations":"globalNotifcations","help":"help","home~media":"home~media","home":"home","media":"media","interviewContestList":"interviewContestList","login":"login","mediaDetails":"mediaDetails","myFavourites":"myFavourites","passwordChanged":"passwordChanged","paymentConfirmation":"paymentConfirmation","paymentHistory":"paymentHistory","paypalPayment":"paypalPayment","publicCourseDetails":"publicCourseDetails","register":"register","researchPapers":"researchPapers","researchPapersFavouritesList~researchPapersList~researchPapersSharedList":"researchPapersFavouritesList~researchPapersList~researchPapersSharedList","researchPapersFavouritesList":"researchPapersFavouritesList","researchPapersSharedList":"researchPapersSharedList","researchPapersGroupList~researchPapersList~updateUserProfile~workspace":"researchPapersGroupList~researchPapersList~updateUserProfile~workspace","pdfjs-dist":"pdfjs-dist","researchPapersList~workspace":"researchPapersList~workspace","researchPapersList":"researchPapersList","researchPapersGroupList":"researchPapersGroupList","updateUserProfile~userProfile~workspace":"updateUserProfile~userProfile~workspace","workspace":"workspace","updateUserProfile":"updateUserProfile","researchPapersTrashList":"researchPapersTrashList","searchResults":"searchResults","underMaintenance":"underMaintenance","userProfile":"userProfile","uploadSolution":"uploadSolution","userAgreement":"userAgreement","userDashboard":"userDashboard","userQuiz":"userQuiz","userReqListPage":"userReqListPage","userVerified":"userVerified","filestack":"filestack","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"AboutUs":"aa63de08","AllUsersList":"f14c2b21","ContactUs":"6209fd85","allCategoriesPage":"df7d6f30","assignement":"5dbbcf6f","assignmentBrief":"6a3dd56c","categoryProject":"073ca042","contest":"d5b388dc","contestQuiz~courseCategory~courseQuiz~interviewContestDashboard":"382aca5b","contestQuiz":"423757d8","courseCategory~publicCourseDescription":"f976be29","courseCategory":"f9d8c92b","courseQuiz":"7d55b90c","interviewContestDashboard":"3aea28fd","publicCourseDescription":"f3762e3d","courseDetail":"b6eb8a1b","courseList":"3001164f","coursesBycategory":"76c3fc05","coursesdescription~interViewCourseDetails~testimonials":"b1561596","coursesdescription":"dd87df93","interViewCourseDetails":"a16bfd14","testimonials":"b8dacbb7","forgotPassword":"0a94b49d","globalNotifcations":"ad3306f4","help":"89280218","home~media":"e8b012e0","home":"535c5f4b","media":"b3562f1d","interviewContestList":"62106b90","login":"a61d7496","mediaDetails":"37cc721d","myFavourites":"8d3e6242","passwordChanged":"61746f92","paymentConfirmation":"52a2b324","paymentHistory":"a0ca6585","paypalPayment":"5a1ea8fb","publicCourseDetails":"8b41ad3d","register":"9ad1e854","researchPapers":"da8a6ac2","researchPapersFavouritesList~researchPapersList~researchPapersSharedList":"127716ea","researchPapersFavouritesList":"868179c5","researchPapersSharedList":"e71fcc91","researchPapersGroupList~researchPapersList~updateUserProfile~workspace":"bc36350e","pdfjs-dist":"1a4023ca","researchPapersList~workspace":"3ce86e41","researchPapersList":"ad54fd9c","researchPapersGroupList":"fdaf5dd5","updateUserProfile~userProfile~workspace":"768cc56c","workspace":"a727eea3","updateUserProfile":"e0020642","researchPapersTrashList":"641b2bfc","searchResults":"ac023d99","underMaintenance":"d7e7f3b2","userProfile":"f992b5e1","uploadSolution":"f2efa2ad","userAgreement":"ab828424","userDashboard":"74c60d72","userQuiz":"2d9b3378","userReqListPage":"e060de3f","userVerified":"3cd8f7f1","filestack":"2767b329","pdfjsWorker":"783a4eb0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AboutUs":1,"AllUsersList":1,"ContactUs":1,"allCategoriesPage":1,"assignement":1,"assignmentBrief":1,"categoryProject":1,"contest":1,"contestQuiz~courseCategory~courseQuiz~interviewContestDashboard":1,"contestQuiz":1,"courseCategory~publicCourseDescription":1,"courseCategory":1,"courseQuiz":1,"interviewContestDashboard":1,"publicCourseDescription":1,"courseDetail":1,"courseList":1,"coursesBycategory":1,"coursesdescription":1,"interViewCourseDetails":1,"testimonials":1,"forgotPassword":1,"globalNotifcations":1,"help":1,"home~media":1,"home":1,"media":1,"interviewContestList":1,"login":1,"mediaDetails":1,"myFavourites":1,"passwordChanged":1,"paymentConfirmation":1,"paymentHistory":1,"paypalPayment":1,"publicCourseDetails":1,"register":1,"researchPapers":1,"researchPapersFavouritesList~researchPapersList~researchPapersSharedList":1,"researchPapersFavouritesList":1,"researchPapersSharedList":1,"researchPapersList":1,"researchPapersGroupList":1,"updateUserProfile~userProfile~workspace":1,"workspace":1,"updateUserProfile":1,"researchPapersTrashList":1,"searchResults":1,"underMaintenance":1,"userProfile":1,"uploadSolution":1,"userAgreement":1,"userDashboard":1,"userQuiz":1,"userReqListPage":1,"userVerified":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AboutUs":"AboutUs","AllUsersList":"AllUsersList","ContactUs":"ContactUs","allCategoriesPage":"allCategoriesPage","assignement":"assignement","assignmentBrief":"assignmentBrief","categoryProject":"categoryProject","contest":"contest","contestQuiz~courseCategory~courseQuiz~interviewContestDashboard":"contestQuiz~courseCategory~courseQuiz~interviewContestDashboard","contestQuiz":"contestQuiz","courseCategory~publicCourseDescription":"courseCategory~publicCourseDescription","courseCategory":"courseCategory","courseQuiz":"courseQuiz","interviewContestDashboard":"interviewContestDashboard","publicCourseDescription":"publicCourseDescription","courseDetail":"courseDetail","courseList":"courseList","coursesBycategory":"coursesBycategory","coursesdescription~interViewCourseDetails~testimonials":"coursesdescription~interViewCourseDetails~testimonials","coursesdescription":"coursesdescription","interViewCourseDetails":"interViewCourseDetails","testimonials":"testimonials","forgotPassword":"forgotPassword","globalNotifcations":"globalNotifcations","help":"help","home~media":"home~media","home":"home","media":"media","interviewContestList":"interviewContestList","login":"login","mediaDetails":"mediaDetails","myFavourites":"myFavourites","passwordChanged":"passwordChanged","paymentConfirmation":"paymentConfirmation","paymentHistory":"paymentHistory","paypalPayment":"paypalPayment","publicCourseDetails":"publicCourseDetails","register":"register","researchPapers":"researchPapers","researchPapersFavouritesList~researchPapersList~researchPapersSharedList":"researchPapersFavouritesList~researchPapersList~researchPapersSharedList","researchPapersFavouritesList":"researchPapersFavouritesList","researchPapersSharedList":"researchPapersSharedList","researchPapersGroupList~researchPapersList~updateUserProfile~workspace":"researchPapersGroupList~researchPapersList~updateUserProfile~workspace","pdfjs-dist":"pdfjs-dist","researchPapersList~workspace":"researchPapersList~workspace","researchPapersList":"researchPapersList","researchPapersGroupList":"researchPapersGroupList","updateUserProfile~userProfile~workspace":"updateUserProfile~userProfile~workspace","workspace":"workspace","updateUserProfile":"updateUserProfile","researchPapersTrashList":"researchPapersTrashList","searchResults":"searchResults","underMaintenance":"underMaintenance","userProfile":"userProfile","uploadSolution":"uploadSolution","userAgreement":"userAgreement","userDashboard":"userDashboard","userQuiz":"userQuiz","userReqListPage":"userReqListPage","userVerified":"userVerified","filestack":"filestack","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "." + {"AboutUs":"4bbde924","AllUsersList":"b94a60f4","ContactUs":"afd8e635","allCategoriesPage":"abc8eb7c","assignement":"5e7c5170","assignmentBrief":"5c61cee0","categoryProject":"fbb810c3","contest":"c93f1a47","contestQuiz~courseCategory~courseQuiz~interviewContestDashboard":"9233277a","contestQuiz":"672952ea","courseCategory~publicCourseDescription":"97e10ce7","courseCategory":"268a8a27","courseQuiz":"b83406e5","interviewContestDashboard":"a2569871","publicCourseDescription":"859c95fd","courseDetail":"843ecf71","courseList":"fcbce0e3","coursesBycategory":"d1b5ed15","coursesdescription~interViewCourseDetails~testimonials":"31d6cfe0","coursesdescription":"66d94d65","interViewCourseDetails":"ca45324d","testimonials":"6ee6ac09","forgotPassword":"9bb19f38","globalNotifcations":"985a52e1","help":"a742c47c","home~media":"acc7102d","home":"d405cdd8","media":"afb8eab6","interviewContestList":"5e097ec3","login":"5da8e32e","mediaDetails":"06123624","myFavourites":"6ac373ce","passwordChanged":"85807b67","paymentConfirmation":"cb110a5c","paymentHistory":"e10259ab","paypalPayment":"6415edd1","publicCourseDetails":"363837a4","register":"11051d96","researchPapers":"58879483","researchPapersFavouritesList~researchPapersList~researchPapersSharedList":"07d1c846","researchPapersFavouritesList":"c6a26ec2","researchPapersSharedList":"f79f2ef9","researchPapersGroupList~researchPapersList~updateUserProfile~workspace":"31d6cfe0","pdfjs-dist":"31d6cfe0","researchPapersList~workspace":"31d6cfe0","researchPapersList":"ee4e4e7d","researchPapersGroupList":"b5aad9ba","updateUserProfile~userProfile~workspace":"d627bc19","workspace":"7ab6bb94","updateUserProfile":"9df83b51","researchPapersTrashList":"a8333034","searchResults":"aa0b7204","underMaintenance":"bb97ffb5","userProfile":"5a109ff7","uploadSolution":"3ac91f03","userAgreement":"1f3ecf6c","userDashboard":"85697b86","userQuiz":"7065def7","userReqListPage":"350dcd1c","userVerified":"3b83e7c4","filestack":"31d6cfe0","pdfjsWorker":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
